// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navMenu {
  font-family: "Roboto";
  border: none;
  background: none;
  font-weight: 400;
  color: gray;
}
.navbar-logo-container {
  width: 100%;
  height: 100%;
  max-width: 400px;
}
/* changed by ashok */
.navbar-navigation-button-link {
  font-family: "HelveticaNeue-Medium", "Helvetica Neue Medium", "Helvetica Neue", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #443f7a;
  border-radius: 5px;
  margin-bottom: 8px;
}
.navbar-welcome-text{
  display: none !important;
}

@media (min-width: 998px) {
  .navbar-navigation-button-link {
    margin-left: 8px;
    margin-bottom: 0px;
    background-color: #ffffff;
    border: 1.5px solid #a5a5a5;
  }

  .navbar-welcome-text{
    display: block !important;
  }
}

.logout-bt {
    border: 0;
    cursor: pointer;
    background: none;
}
/*changes end */

.headerImg {
  display: flex;
  flex-direction: row;
}

.heading {
  font-size: 24px;
  font-weight: bold;
  display: flex;
  align-items: center;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA,qBAAqB;AACrB;EACE,0FAA0F;EAC1F,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;AACA,eAAe;;AAEf;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".navMenu {\n  font-family: \"Roboto\";\n  border: none;\n  background: none;\n  font-weight: 400;\n  color: gray;\n}\n.navbar-logo-container {\n  width: 100%;\n  height: 100%;\n  max-width: 400px;\n}\n/* changed by ashok */\n.navbar-navigation-button-link {\n  font-family: \"HelveticaNeue-Medium\", \"Helvetica Neue Medium\", \"Helvetica Neue\", sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  color: #443f7a;\n  border-radius: 5px;\n  margin-bottom: 8px;\n}\n.navbar-welcome-text{\n  display: none !important;\n}\n\n@media (min-width: 998px) {\n  .navbar-navigation-button-link {\n    margin-left: 8px;\n    margin-bottom: 0px;\n    background-color: #ffffff;\n    border: 1.5px solid #a5a5a5;\n  }\n\n  .navbar-welcome-text{\n    display: block !important;\n  }\n}\n\n.logout-bt {\n    border: 0;\n    cursor: pointer;\n    background: none;\n}\n/*changes end */\n\n.headerImg {\n  display: flex;\n  flex-direction: row;\n}\n\n.heading {\n  font-size: 24px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
